import { html, repeat } from '@microsoft/fast-element';
import { MetricTile } from './metrics-tile';

export const MetricTileTemplate = html<MetricTile>`
  ${repeat(
    (x) => x.vppaMetrics,
    html`
      <div class="tile-header">${(x) => x.READABLE_FIELD_NAME}</div>
      <div class="tile">
        <div class="tile-content">
          <div class="vppa-value">
            <div class="header">This Contract</div>
            <div class="value">${(x, c) => c.parent.formatValues(x.VALUE, x.FIELD_NAME)}</div>
          </div>
          <div class="vppa-ranking">
            <div class="value" style="left: ${(x, c) => c.parent.getPosition(x.RANKING)}">
              ${(x) => (x.RANKING ? x.RANKING : 0)}
            </div>
          </div>
          <div class="all-vppa-average">
            <div class="header">All Contract Avg</div>
            <div class="value">${(x, c) => c.parent.formatValues(x.AVERAGE, x.FIELD_NAME)}</div>
          </div>
        </div>
      </div>
    `
  )}
`;
